import { render, staticRenderFns } from "./FormasPagamentoLista.vue?vue&type=template&id=6ad82882&scoped=true&"
import script from "./FormasPagamentoLista.vue?vue&type=script&lang=js&"
export * from "./FormasPagamentoLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad82882",
  null
  
)

export default component.exports